<template>
  <div
    class="ui-switcher-item"
    :class="classList"
    v-on="$listeners"
    @click="setActiveItem"
  >
    <ui-icon
      class="ui-switcher-item__icon"
      v-if="icon"
      :name="icon"
      :height="iconHeight"
      :width="iconWidth"
    />
    <span>
      {{ title }}
    </span>
    <div
      v-if="hasBadge"
      class="ui-switcher-item-badge-list"
    >
      <ui-skeleton
        v-if="countLoading"
        class="ui-switcher-item-badge-loading"
      />
      <template v-else>
        <ui-tab-badge
          v-if="count"
          key="count"
          class="ui-switcher-item-badge-list__item"
          type="primary"
        >
          {{ count }}
        </ui-tab-badge>
        <ui-tab-badge
          v-if="dangerCount"
          key="dangerCount"
          class="ui-switcher-item-badge-list__item"
          type="danger"
        >
          {{ dangerCount }}
        </ui-tab-badge>
      </template>
    </div>

  </div>
</template>

<script>
import UiSkeleton from '../skeleton/UiSkeleton.vue'
import UiIcon from '../icons/UiIcon.vue'
import UiTabBadge from '../tabs/UiTabBadge.vue'

export default {
  name: 'UiSwitcherItem',
  components: { UiSkeleton, UiIcon, UiTabBadge },
  props: {
    title: {
      type: [String, Number],
      default: 'Text'
    },
    type: {
      type: String,
      default: 'default',
      validator (type) {
        return ['default', 'primary'].indexOf(type) !== -1
      }
    },
    activeId: [Number, String],
    id: [Number, String],
    count: [Number, String],
    dangerCount: [String, Number],
    icon: String,
    iconHeight: {
      type: Number,
      default: 20
    },
    iconWidth: {
      type: Number,
      default: 20
    },
    countLoading: {
      type: Boolean,
      default: false
    },
    canToggle: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classList () {
      return [`type-${this.type}`, { active: this.isActive }]
    },
    hasBadge () {
      return this.countLoading || this.count || this.dangerCount
    },

    isActive () {
      return this.activeId === this.id
    }
  },

  methods: {
    setActiveItem () {
      if (!this.canToggle && this.isActive) return
      this.$parent.$emit('active-item', this)
    }
  },

  watch: {
    activeInit: {
      handler (value) {
        this.active = value
      },

      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
$transition: .2s;
.ui-switcher-item {
  $switcher: &;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 40px;
  padding: 10px 15px;
  overflow: hidden;
  color: $black-01;
  font-size: 16px;
  font-family: $main-ff;
  text-align: center;
  fill: $black-01;
  border: solid 1px $gray-01;
  border-right: initial;
  white-space: nowrap;
  user-select: none;
  transition: all $transition;
  cursor: pointer;

  ::v-deep() {
    @include nextChildren {
      margin-left: 10px;
    }
  }

  &:hover {
    color: $primary;
    fill: $primary;
  }

  &.active {
    color: $primary;
    fill: $primary;
    background: $gray-7;
  }

  &__icon {
    flex-shrink: 0;
  }

  &.type-primary {

    &:hover,
    &.active {
      color: $light-01;
      fill: $light-01;
      background-color: $primary;
      border-color: $primary;

      .ui-switcher-item-badge-list__item {
        color: $light-01;
        background-color: $primary;
        filter: brightness(90%);
      }
    }
  }
}

.ui-switcher-item-badge-list {
  display: flex;
  margin-left: 10px;

  @include nextChildren {
    margin-left: 8px;
  }
}

.ui-switcher-item-badge-loading {
  @include skeleton(20px, $border-radius-01);
  width: 20px;
}
</style>
